import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as saveAs from 'file-saver';
import { Message, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { UIService } from 'src/app/core/services/ui.service';
import { DashboardIndicador } from 'src/app/modelo/DashboardIndicador';
import { FiltroData } from 'src/app/modelo/FiltroData';
import { FiltrosData } from 'src/app/modelo/FiltrosData';
import { Reporte } from 'src/app/modelo/Reporte';
import { environment } from 'src/environments/environment';
import { AdministracionService } from '../administracion.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
    
    //Variables de configuración/mensajes
    appConfig = environment.settings;
    
    errors: Object = {};
    msgs: Message[] = [];

    products: any[];

    cols: any[];

    chartData: any;

    chartOptions: any;


    catalogoReportes: Reporte[] = [];
    reporte: Reporte = new Reporte();
    indicador: DashboardIndicador = new DashboardIndicador();
    indicadores: DashboardIndicador[] = [];
    mostrarSelectorReporte: boolean = false;

    //Variables de reportes
    mostrarVisualidorReporteRIDE: boolean = false;
    mostrarVisualidorReporteXML: boolean = false;
    mostrarVisualidorReporte: boolean = false;
    reporteGenerado: boolean = false;
    reporteURL: any; //Para lanzar el popup de vista previa
    reporteBLOB: any; //Para descargar el reporte
    
    ui: UIService;
    
    procesando: boolean = false;
    processFilter = false;
    
    dtRangeInit: Date;
    dtRangeEnd: Date;
    dtRangeMonth: boolean = false;

    filtrosData: FiltrosData = new FiltrosData();



    constructor(
        private breadcrumbService: BreadcrumbService,
        private router: Router,
        private route: ActivatedRoute,
        private uiService: UIService,
        private administracionService: AdministracionService,
        private messageService: MessageService,) {
            
        this.ui = uiService;
        this.breadcrumbService.setItems([
            {label: 'Dashboard', routerLink: ['/']}
        ]);
    }

    ngOnInit() {
//        this.productService.getProducts().then(data => this.products = data);
        this.products = []
        this.chartData = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            datasets: [{
                label: 'Armas de fuego',
                data: [12, 19, 3, 5, 2, 3, 9],
                borderColor: [
                    '#4CAF50',
                ],
                borderWidth: 3,
                borderDash: [5, 5],
                fill: false,
                pointRadius: 3
            }, {
                label: 'Tráfico de hidrocarburos',
                data: [1, 2, 5, 3, 12, 7, 15],
                backgroundColor: [
                    'rgba(187,222,251,0.2)',
                ],
                borderColor: [
                    '#00BCD4',
                ],
                borderWidth: 3,
                fill: true
            },
                {
                    label: 'Explosivos',
                    data: [7, 12, 15, 5, 3, 13, 21],
                    borderColor: [
                        '#e91e63',
                    ],
                    borderWidth: 3,
                    fill: false,
                    pointRadius: [4, 6, 4, 12, 8, 0, 4]
                },
                {
                    label: 'Narcotráfico',
                    data: [3, 7, 2, 17, 15, 13, 19],
                    borderColor: [
                        '#FF8F00',
                    ],
                    borderWidth: 3,
                    fill: false
                }]
        };

        this.chartOptions = {
            responsive: true,
            hover: {
                mode: 'index'
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Month'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Value'
                    }
                }]
            }
        };

        this.cargarDataInit();
    }
    
    async cargarDataInit() {
        //Cargar indicadores
        const dashboardId = 1; //el contenedor de indicadores para Fazil 1
        this.indicadores = await this.administracionService.getDashboardIndicadoresPorDashboardData(dashboardId);
        
//        console.log(this.indicadores);
        //Cargar reportes
        this.catalogoReportes = await this.administracionService.getReportesPorModuloClaseData(this.router.url, 'lista');
    }
    
    
    generateItemsToPDFByReporte(event) {
        this.ui.limpiarMessages();
        this.reporte = new Reporte();
        if (false && this.catalogoReportes && this.catalogoReportes.length == 1) {
            //Generar el reporte directamente
            this.reporte = this.catalogoReportes[0];
            this.generarReportePorFiltros(event);
        } else {
            //Seleccionar el reporte de la lista
            this.mostrarSelectorReporte = true;
        }
    }

    /**
    * Manejo de reportes
    */
    async generarReportePorFiltros(event: any) {
        this.reporteBLOB = null;
        this.reporteURL = null;
        this.reporteGenerado = false;
        this.mostrarVisualidorReporte = false;
        this.filtrosData.filtros = [];
        this.filtrosData.tipo = "excel";
        let filtro;

        filtro = new FiltroData();
        filtro.token = 'Titulo';
        filtro.valor = this.reporte.name;
        this.filtrosData.filtros.push(filtro);

        filtro = new FiltroData();
        
        if (this.dtRangeInit) {//Cargar el filtro de fechas

            filtro = new FiltroData();
            filtro.token = 'fechaInicial';
            filtro.valor = "" + this.dtRangeInit.toLocaleDateString();
            filtro.tipo = "Date";
            this.filtrosData.filtros.push(filtro);

            filtro = new FiltroData();
            filtro.token = 'fechaFinal';
            filtro.tipo = "Date";

            if (this.dtRangeEnd) {
                filtro.valor = "" + this.dtRangeEnd.toLocaleDateString();
            } else {
                filtro.valor = "" + new Date().toLocaleDateString();
            }
            this.filtrosData.filtros.push(filtro);
        }


        //Solicitar reporte con filtros
        if (this.filtrosData && this.filtrosData.filtros && this.filtrosData.filtros.length > 0) {

            //Parámetros del reporte
            if (this.reporte.url && this.reporte.url != '') {
                this.procesando = true;
                this.administracionService.generarReportePorFiltros(this.reporte.uuid, this.filtrosData).subscribe(
                    (responseBlob: any) => {

                        let blob: any = new Blob([responseBlob], { type: responseBlob.type });

                        if (this.filtrosData.tipo == 'pdf') {
                            const fileReader = new FileReader();
                            fileReader.onload = () => {
                                this.reporteURL = new Uint8Array(fileReader.result as ArrayBuffer);
                                this.reporteGenerado = true;
                                this.mostrarVisualidorReporte = true;
                                this.procesando = false;

                            };
                            if (blob['type'] != '' && blob['size'] != 0) {
                                fileReader.readAsArrayBuffer(blob);
                                this.reporteBLOB = blob;
                            } else {
                                this.reporteGenerado = false;
                                this.mostrarVisualidorReporte = true;
                                this.procesando = false;
                            }
                        } else {
                            this.saveAsEXCELFile(blob, this.reporte.name);
                            this.reporteGenerado = true;
                            this.mostrarVisualidorReporte = false;
                            this.procesando = false;
                        }

                    },
                    (err) => {
                        this.errors = err["errors"];
                        this.messageService.add({
                            severity: "error",
                            summary: this.errors["type"],
                            detail: `${this.errors["message"]}`,
                        });
                    }
                );
            } else {
                this.messageService.add({
                    severity: "error",
                    summary: "Reporte inconsistente",
                    detail: `${this.reporte["nombre"]} no esta correctamente definido. Consulte con el administrador.`,
                });

                this.procesando = false;
            }
        }
    }

    /**
    **Manejo de filtros
    **/
    onFilterDate(event) {//Aplicar todos los filtros
        if (this.dtRangeInit && this.dtRangeEnd) {
            this.dtRangeInit.setHours(0, 0, 0, 0);
            this.dtRangeEnd.setHours(23, 59, 59, 59);
        } else if (this.dtRangeInit) {
            this.dtRangeInit.setHours(0, 0, 0, 0);
        } else {
        }
    }

    onFilterDateRange(event) {
        if (event) {
            this.dtRangeInit = null;
            this.dtRangeEnd = null;
            if (event.checked) {
                this.dtRangeInit = new Date();
                //                if (new Date().getMonth().valueOf() == 0) {
                //                    this.dtRangeInit.setFullYear(new Date().getFullYear() - 1, 11, new Date().getDay());
                //                } else {
                this.dtRangeInit.setMonth(new Date().getMonth() - 1);
                //                }
                this.dtRangeInit.setHours(0, 0, 0, 0);
                this.dtRangeEnd = new Date();
                this.dtRangeEnd.setHours(23, 59, 59, 59);
            } else {
                this.dtRangeInit = null;//Enserar el rango de fechas
                this.dtRangeEnd = null;
            }
        }
    }

    async limpiarFiltros() {
        this.dtRangeInit = null;
        this.dtRangeEnd = null;
        //this.tipoFiltro = null;
        this.reporte = new Reporte();
        this.dtRangeMonth = false;
    }
    
    /**
    * Manejo de archivos EXCEL
    */
    saveAsEXCELFile(blob: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let ZIP_EXTENSION = '.xls';
            const path = fileName + '_descarga_' + new Date().getTime().toString() + ZIP_EXTENSION;
            saveAs(blob, path);
        });
    }
    
    irASucripciones(){
        this.uiService.ejecutarAccionResultFromData(null, 'suscripciones');
    }
}
